import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { PublicTicketFormPage } from '../../pages/public/FormulaireForCllientPage'
import { PublicTicketTrackingPage } from '../../pages/public/PublicTicketTrackingPage'

export default function PublicTicketNav() {
    return (
        <Routes>
            <Route path="/:slug/:id" element={<PublicTicketFormPage />} />
            <Route path="/tracking" element={<PublicTicketTrackingPage />} />

        </Routes>
    )
}
